export const languages = [
  { label: 'Chinese', value: 'chinese' },
  { label: 'English', value: 'english' },
];

export const energyEmissionInfo = {
  title: 'The uncertainty of the high resolution inventory for the energy sector is strongly linked to the quality of the proxy data used in the downscaling.',
  description: 'We have invested a significant amount of time in improving open source powerplant databases for three air pollution hotspots: the Beijing - Tianjin area, the Yangtze River Delta and the Pearl River Delta.As this extensive quality control has only occurred for these three areas, the uncertainty for the powerplant emissions outside these domains is significantly larger.',
  note: 'This is a sample data set. Note that full data sets, available for purchase, show monthly information for industry, fires, residential, traffic and energy.'
};

export const citiesInfo = [
  {
    label: 'Shanghai',
    value: 'Shanghai',
    location: { lat: '31.2304', long: '121.4737' }
  },
  {
    label: 'Mudu',
    value: 'Mudu',
    location: { lat: '31.2589', long: '120.5172' },
  },
  {
    label: 'Jiangdu',
    value: 'Jiangdu',
    location: { lat: '32.4347', long: '119.5700' }
  }
];

export const DEFAULT_YEAR = 2017;

export const pollutantsInfo = {
  BC: {
    displayName: 'Black carbon',
    description: 'Black carbon consists of pure carbon in several linked forms. It is formed through the incomplete combustion of fossil fuels, biofuel, and biomass, and is emitted in both anthropogenic and naturally occurring soot.',
  },
  NH3: {
    displayName: 'Ammonia',
    description: 'Ammonia is a compound of nitrogen and hydrogen with the formula NH3. The simplest pnictogen hydride, ammonia, is a colourless gas with a characteristic pungent smell. It is a common nitrogenous waste, particularly among aquatic organisms, and it contributes significantly to the nutritional needs of terrestrial organisms by serving as a precursor to food and fertilizers.',
  },
  NOx: {
    displayName: 'Nitrogen oxides',
    description: 'In atmospheric chemistry, NOx is a generic term for the nitrogen oxides that are most relevant for air pollution, namely nitric oxide (NO) and nitrogen dioxide (NO2). NOx gases are usually produced from the reaction among nitrogen and oxygen during combustion of fuels, such as hydrocarbons, in air; especially at high temperatures, such as occur in car engines.',
  },
  NO: {
    displayName: 'Nitric oxide',
    description: 'Nitric oxide (nitrogen oxide or nitrogen monoxide) is a colorless gas with the formula NO. Nitric oxide forms in combustion systems and can be generated by lightning in thunderstorms.',
  },
  NO2: {
    displayName: 'Nitrogen dioxide',
    description: 'Nitrogen dioxide is the chemical compound with the formula NO2. NO2 is an intermediate in the industrial synthesis of nitric acid, millions of tons of which are produced each year which is used primary in production of fertilizers.',
  },
  O3: {
    displayName: 'Ozone',
    description: "Ozone, or trioxygen, is an inorganic molecule with the chemical formula O3. It is a pale blue gas with a distinctively pungent smell. Ozone is formed from dioxygen by the action of ultraviolet light (UV) and electrical discharges within the Earth's atmosphere.",
  },
  PM10: {
    displayName: 'Particulate matter 10',
    description: 'PM10 is a particular type of particulate matter, microscopic solid or liquid matter suspended in the atmosphere of Earth. PM10 is the name given to particles with a diameter between 2.5 and 10 micrometers.',
  },
  PM25: {
    displayName: 'Particulate matter 2.5',
    description: 'PM2.5 is a particular type of particulate matter, microscopic solid or liquid matter suspended in the atmosphere of Earth. PM2.5 is the name given to particles with a diameter smaller than 2.5 micrometers.',
  },
  SO2: {
    displayName: 'Sulfur dioxide',
    description: 'Sulfur dioxide is the chemical compound with the formula SO2. It is a toxic gas with a burnt match smell. It is released naturally by volcanic activity and is produced as a by-product of the burning of fossil fuels contaminated with sulfur compounds and copper extraction.',
  },
  CO: {
    displayName: 'Carbon monoxide',
    description: 'Carbon monoxide (CO) is a colorless, odorless, and tasteless gas that is slightly less dense than air. It forms when there is not enough oxygen to produce carbon dioxide (CO2), such as when operating a stove or an internal combustion engine in an enclosed space. It is also produced in normal animal metabolism in low quantities.',
  },
  VOC: {
    displayName: 'Volatile organic compounds',
    description: 'Volatile organic compounds (VOCs) are organic chemicals that have a high vapor pressure at ordinary room temperature. They include both human-made (e.g. scents and odors) and naturally occurring chemical compounds (e.g. isoprene).',
  },
};

export const defaultPollutants = {
  HI_RES_INVENTORY: {
    defaultVariable: 'Particulate matter 2.5',
    defaultSector: 'Total'
  }
};

export const dictionary = {
  Amsterdam: {
    latMax: 52.3588175659181,
    latMin: 52.357782440185496,
    lonMax: 5.02532243728638,
    lonMin: 4.72472238540649
  },
  'East China': {
    latMax: 39.9042,
    latMin: 23.1291,
    lonMax: 116.4074,
    lonMin: 113.2644
  },
  Shanghai: {
    latMax: 31.2504,
    latMin: 31.2104,
    lonMax: 123.4737,
    lonMin: 119.4737
  },
  Mudu: {
    latMax: 31.2689,
    latMin: 31.1989,
    lonMax: 120.7072,
    lonMin: 120.4072
  },
  Jiangdu: {
    latMax: 32.4547,
    latMin: 32.4147,
    lonMax: 119.7500,
    lonMin: 119.5500
  }
};

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

// Values requested to show in demos

export const allowList = [
  'July'
];



// WEBPACK FOOTER //
// ./src/components/emissions-demo/constants.js